<template>
  <div
    class="key-takeaway"
    :class="{
      'highlighted': highlighted,
    }"
  >
    <icon-card
      :highlighted="highlighted"
    >
      <template #icon>
        <icon
          name="trophy"
          variant="326ff0"
          class="icon"
        ></icon>
      </template>
      <template #title>
        Key Takeaway
      </template>
      <div class="content">
        <slot></slot>
      </div>
    </icon-card>
  </div>
</template>

<script>
import IconCard from '@components/flashcards-v2/fragments/IconCard';
import Icon from '@/components/singletons/icon';

export default {
  components: {
    Icon,
    IconCard,
  },
  props: {
    highlighted: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.key-takeaway {
  margin-top: 1.5rem;
  background-color: #F9FAFB;
  border-radius: var(--radius-xs);

  :deep(.icon-card) {
    .icon-slot {
      margin-top: 2px;
    }
  }
}
</style>
